import React from 'react';
import { Box, Avatar, Paragraph, Anchor, Image, ResponsiveContext, Tip, Text } from 'grommet';
import googleCloud from '../images/googleCloud.png'
import blockmaster from '../images/blockmaster.png'
import btgcode from '../images/btgcode.png'
import igcChallenge from '../images/igcChallenge.png'
import brasaHacks from '../images/brasaHacks.png'
import nexodata from '../images/nexodata.png'
import profile from '../images/profile.png'
import { Node, Reactjs, Windows, Mysql, Github } from 'grommet-icons';
import { FaPython, FaJava, FaGitAlt, FaAws } from "react-icons/fa";
import { SiTypescript, SiFlutter, SiGooglecloud, SiPostgresql } from "react-icons/si";
import { AiOutlineBlock } from "react-icons/ai";
import { FcLinux } from "react-icons/fc";
import { FormControlLabel, FormGroup, Switch, withStyles } from "@material-ui/core"

const styleTextHeader = {
    color: '#300A45',
    size: 'xxlarge',
    marginRight: '2%'
};

const styleTextContent = {
    color: '#300A45',
    size: 'medium',
};

const PurpleSwitch = withStyles({
    switchBase: {
        color: "#300A45",
        '&$checked': {
            color: "#300A45",
        },
        '&$checked + $track': {
            backgroundColor: "#300A45",
        },
    },
    checked: {},
    track: {},
})(Switch);



const Content = () => {
    
    const [state, setState] = React.useState({
        checked: false,
    });

    const handleChange = (event: any) => {
        setState({ ...state, [event.target.name]: event.target.checked });
    };



    return (
        <>
            <Box animation={[{ "type": "zoomIn", "duration": 1500 }]} direction="row-responsive" pad="small" responsive={true} justify="center">
                <Avatar size="xlarge" src={profile} alignSelf="center" margin={styleTextHeader.marginRight} />
                <Paragraph size={styleTextHeader.size} color={styleTextHeader.color} textAlign="center">
                    Pedro Paulo Mendonça Telho
                </Paragraph>
                <Box responsive={true} pad="small" direction="row-responsive" justify="stretch">
                    <FormGroup color="#300A45">
                        <FormControlLabel
                            control={<PurpleSwitch checked={state.checked} onChange={handleChange} name="checked" />}
                            label={state.checked === false ? "Translate" : "Traduzir"}
                        />
                    </FormGroup>
                </Box>

            </Box>
            <Box animation={[{ "type": "slideRight", "duration": 2000 }]} direction="row-responsive" responsive={true} justify="center">
                <Paragraph style={{ textAlign: 'justify', marginRight: '5%', marginLeft: '5%', }} size={styleTextContent.size} color={styleTextHeader.color} alignSelf="center">
                    {state.checked === false ? (<>Olá, sou estudante de engenharia de computação pelo Insper-SP. Amo conhecer coisas novas, estar por dentro
                        da tecnologia e fazer a diferença no mundo. A comunicação para mim é o diferencial nesse vasto universo e acredito
                        que ela pode ter um potencial ainda maior. Por isso, criei o canal <Anchor href="https://www.youtube.com/channel/UCrmaaJREls_mI34UZhK-0Cg?view_as=subscriber">TechProChannel</Anchor> com o intuito de fazer
                        a diferença na vida das pessoas, fomentando ainda mais o ensino de programação.</>) : (<>Hey, I'm a computer engineering student from Insper-Brazil. I love being in contact with new discoveries, being inside of the tech environment
                            and making a difference in the world. Communication for me is a big differential in the universe and I believe that it can have an even great potential. Therefore, I founded the <Anchor href="https://www.youtube.com/channel/UCrmaaJREls_mI34UZhK-0Cg?view_as=subscriber">TechProChannel </Anchor>
                            hoping to make a difference in people's life, fostering even more code teaching.</>)}
                </Paragraph>
            </Box>
            <Box animation={[{ "type": "slideLeft", "duration": 2750 }]} direction="row-responsive" pad="small" responsive={true} justify="center">
                <Paragraph size={styleTextHeader.size} color={styleTextHeader.color} textAlign="center">
                    {state.checked === false ? (<>Experiências</>) : (<>Experiences</>)}
                </Paragraph>
            </Box>
            <Box animation={[{ "type": "slideRight", "duration": 3000 }]} direction="row-responsive" responsive={true} justify="center">
                <Paragraph style={{ textAlign: 'justify', marginRight: '5%', marginLeft: '5%', }} size={styleTextContent.size} color={styleTextHeader.color} alignSelf="center">
                    {state.checked === false ? (<>Durante minha graduação, participei de algumas conferências que me chamaram a atenção pelo seu conteúdo...
                    </>) : (<>Since I started my graduation, I tried to participate in some conferences which caught my attention with their content...</>)}

                </Paragraph>
            </Box>
            <ResponsiveContext.Consumer>
                {responsive =>
                    responsive === "small" ? (<>
                        <Box animation={[{ "type": "zoomIn", "duration": 3200 }]} direction="row-responsive" justify="center">
                            <Image
                                style={{ width: "80vw", height: "80vh" }}
                                margin="small"
                                fit="contain"
                                src={googleCloud}
                                alignSelf="center"
                            />
                        </Box>
                        <Box animation={[{ "type": "zoomIn", "duration": 3200 }]} direction="row-responsive" justify="center" pad="small">
                            <Image
                                style={{ width: "80vw", height: "80vh" }}
                                margin="small"
                                fit="contain"
                                src={blockmaster}
                                alignSelf="center"
                            />
                        </Box></>
                    ) : (
                        <>
                            <Box animation={[{ "type": "zoomIn", "duration": 3200 }]} direction="row-responsive" justify="center">
                                <Image
                                    style={{ width: "48vw", height: "48vh" }}
                                    margin="small"
                                    fit="contain"
                                    src={googleCloud}
                                    alignSelf="center"
                                />
                            </Box>
                            <Box animation={[{ "type": "zoomIn", "duration": 3200 }]} direction="row-responsive" justify="center" pad="small">
                                <Image
                                    style={{ width: "40vw", height: "40vh" }}
                                    margin="small"
                                    fit="contain"
                                    src={blockmaster}
                                    alignSelf="center"
                                />
                            </Box></>
                    )
                }
            </ResponsiveContext.Consumer>
            <Box animation={[{ "type": "slideRight", "duration": 3000 }]} direction="row-responsive" responsive={true} justify="center">
                <Paragraph style={{ textAlign: 'justify', marginRight: '5%', marginLeft: '5%', }} size={styleTextContent.size} color={styleTextHeader.color} alignSelf="center">
                    {state.checked === false ? (<>Também participei de competições...</>) : (<>I also participated in competitions...</>)}
                </Paragraph>
            </Box>
            <ResponsiveContext.Consumer>
                {responsive =>
                    responsive === "small" ? (<>
                        <Box animation={[{ "type": "zoomIn", "duration": 3200 }]} direction="row-responsive" justify="center">
                            <Image
                                style={{ width: "80vw", height: "80vh" }}
                                margin="small"
                                fit="contain"
                                src={btgcode}
                                alignSelf="center"
                            />
                        </Box>
                        <Box animation={[{ "type": "zoomIn", "duration": 3200 }]} direction="row-responsive" justify="center" pad="small">
                            <Image
                                style={{ width: "80vw", height: "80vh" }}
                                margin="small"
                                fit="contain"
                                src={igcChallenge}
                                alignSelf="center"
                            />
                        </Box>
                        <Box animation={[{ "type": "zoomIn", "duration": 3200 }]} direction="row-responsive" justify="center" pad="small">
                            <Image
                                style={{ width: "80vw", height: "80vh" }}
                                margin="small"
                                fit="contain"
                                src={brasaHacks}
                                alignSelf="center"
                            />
                        </Box>
                    </>
                    ) : (
                        <>
                            <Box animation={[{ "type": "zoomIn", "duration": 3200 }]} direction="row-responsive" justify="center">
                                <Image
                                    style={{ width: "48vw", height: "48vh" }}
                                    margin="small"
                                    fit="contain"
                                    src={btgcode}
                                    alignSelf="center"
                                />
                            </Box>
                            <Box animation={[{ "type": "zoomIn", "duration": 3200 }]} direction="row-responsive" justify="center" pad="small">
                                <Image
                                    style={{ width: "40vw", height: "40vh" }}
                                    margin="small"
                                    fit="contain"
                                    src={igcChallenge}
                                    alignSelf="center"
                                />
                            </Box>
                            <Box animation={[{ "type": "zoomIn", "duration": 3200 }]} direction="row-responsive" justify="center" pad="small">
                                <Image
                                    style={{ width: "40vw", height: "40vh" }}
                                    margin="small"
                                    fit="contain"
                                    src={brasaHacks}
                                    alignSelf="center"
                                />
                            </Box>
                        </>
                    )
                }
            </ResponsiveContext.Consumer>
            <Box animation={[{ "type": "slideRight", "duration": 3000 }]} direction="row-responsive" responsive={true} justify="center">
                <Paragraph style={{ textAlign: 'justify', marginRight: '5%', marginLeft: '5%', }} size={styleTextContent.size} color={styleTextHeader.color} alignSelf="center">
                    {state.checked === false ? (<>Participei do programa de estágio de férias do <b>BTG Pactual</b> 2019/2020, onde trabalhei com o time de tecnologia da área de créditos,
                        e fui bolsista CNPq durante meu projeto de iniciação científica/tecnológica
                        sob orientação do professor e mestre Raul Ikeda Gomes da Silva que possui vasta experiência a respeito do mercado
                        financeiro. (Para mais informações: <Anchor href="https://medium.com/@pedromtelho/blockchain-e-elei%C3%A7%C3%B5es-3af4417338fd">Projeto de iniciação científica/tecnológica</Anchor>).
                    </>)
                        : (<>I was part of the <b>BTG Pactual</b> Summer Intern team of technology 2019/2020, specifically in the credit team, I also
                            was scholarship holder from CNPq during my technology/scientific initiation project under the guidance of professor Raul Ikeda Gomes da Silva
                            who has a lot of experience in the financial market. (For more information: <Anchor href="https://medium.com/@pedromtelho/blockchain-e-elei%C3%A7%C3%B5es-3af4417338fd">Scientific/Technology initiation project</Anchor>) </>)}

                </Paragraph>
            </Box>
            <Box>
                <Paragraph style={{ textAlign: 'justify', marginRight: '5%', marginLeft: '5%', }} size={styleTextContent.size} color={styleTextHeader.color} alignSelf="center">
                    {state.checked === false ? (<>Além disso, trabalhei durante 5 meses na <b>Nexodata</b>, empresa responsável por implementar as prescrições eletrônicas no mercado da
                        saúde. Durante esse tempo, fiquei responsável por auxiliar no desenvolvimento da área de engenharia e inteligência de dados, buscando sempre a melhoria e
                        eficiência dos processos internos para toda a empresa.</>)
                        : (<>I also worked, during 5 months, at <b>Nexodata</b> - a company responsible for implement eletronic doctor prescriptions
                            in the healthcare environment. During this time, I was responsible to contribute to the data engineer and intelligence area development, seeking to innovate and
                            leverage efficiency to the hole company.</>)}
                </Paragraph>
            </Box>
            <ResponsiveContext.Consumer>
                {responsive =>
                    responsive === "small" ? (<>
                        <Box animation={[{ "type": "zoomIn", "duration": 3200 }]} direction="row-responsive" justify="center" pad="small">
                            <Image
                                style={{ width: "80vw", height: "80vh" }}
                                margin="small"
                                fit="contain"
                                src={nexodata}
                                alignSelf="center"
                            />
                        </Box></>
                    ) : (
                        <>
                            <Box animation={[{ "type": "zoomIn", "duration": 3200 }]} direction="row-responsive" justify="center">
                                <Image
                                    style={{ width: "40vw", height: "20vh" }}
                                    margin="small"
                                    fit="contain"
                                    src={nexodata}
                                    alignSelf="center"
                                />
                            </Box>
                        </>
                    )
                }
            </ResponsiveContext.Consumer>
            <Box>
                <Paragraph style={{ textAlign: 'justify', marginRight: '5%', marginLeft: '5%', }} size={styleTextContent.size} color={styleTextHeader.color} alignSelf="center">
                    {state.checked === false ? (<>Em janeiro de 2022 fui convidado a compor o time fundador da empresa <Anchor href="https://www.sqdsocial.com/">SQUADSOCIAL, Inc</Anchor>. <div><br /></div>Atualmente, ocupo o cargo de Blockchain Lead
                        onde desenvolvo softwares capazes de operar em diferentes redes blockchains criando smart contracts, tokens e NFT's para propósitos tanto internos como externos da compania.</>)
                        : (<>In january, 2022, I was invited to be part of the founding team of <Anchor href="https://www.sqdsocial.com/">SQUADSOCIAL, Inc</Anchor>. <div><br /></div>Currently, my role, as a Blockchain Lead, is to build, evaluate and deploy
                            blockchain software solutions such as emition of smart contracts, tokens and NFT's for internal and external company purposes.</>)}
                </Paragraph>
            </Box>
            <Box animation={[{ "type": "slideLeft", "duration": 2750 }]} direction="row-responsive" pad="small" responsive={true} justify="center">
                <Paragraph size={styleTextHeader.size} color={styleTextHeader.color} textAlign="center">
                    {state.checked === false ? (<>Competências</>) : (<>Competencies</>)}
                </Paragraph>
            </Box>
            <Box animation={[{ "type": "slideRight", "duration": 3000 }]} direction="row-responsive" responsive={true} justify="center">
                <Paragraph style={{ textAlign: 'justify', marginRight: '5%', marginLeft: '5%', }} size={styleTextContent.size} color={styleTextHeader.color} alignSelf="center">
                    {state.checked === false ? (<> Trabalhar em grupo, desenvolver coisas novas e comunicar-se são partes do tripé mais importantes que considero
                        durante a minha formação. Com isso, busquei aprender metodologias ágeis, novas tecnologias e tentar comunicar-me ainda mais
                        com o público através do meu canal. Acredito que possuo a capacidade de aprender qualquer coisa e passar esse conhecimento para frente.</>)
                        : (<>Teamwork, developing disruption things and being communicative are the most important parts of my formation tripod. Hence, I tried to learn
                            agile methodologies, new technologies and tried to communicate even more with the public through my YouTube channel. I believe that I have capacity to learn anything
                            and to pass that knowledge forward.</>)}
                </Paragraph>
            </Box>
            <Box animation={[{ "type": "slideLeft", "duration": 2750 }]} direction="row-responsive" pad="small" responsive={true} justify="center">
                <Paragraph size={styleTextHeader.size} color={styleTextHeader.color} textAlign="center">
                    {state.checked === false ? (<>Algumas das tecnologias já trabalhadas</>) : (<>Some of the technologies I have already worked with</>)}
                </Paragraph>
            </Box>
            <ResponsiveContext.Consumer>
                {responsive =>
                    responsive === "small" ? (<>
                        <Box animation={[{ "type": "zoomIn", "duration": 3000 }]} direction="row-responsive" responsive={true} style={{ alignItems: "center" }} justify="center">
                            <div>
                                <Node color="green" style={{ width: "20vw", height: "20vh", marginRight: "4vw", marginLeft: "4vw" }} />
                                <Reactjs color="#00ffff" style={{ width: "20vw", height: "20vh", marginRight: "4vw", marginLeft: "4vw" }} />
                                <Windows style={{ width: "20vw", height: "20vh", marginRight: "4vw", marginLeft: "4vw" }} />
                            </div>
                        </Box>
                        <Box animation={[{ "type": "zoomIn", "duration": 2500 }]} direction="row-responsive" responsive={true} style={{ alignItems: "center" }} justify="center">
                            <div>
                                <SiTypescript color="#2C77AC" style={{ width: "20vw", height: "20vh", marginRight: "4vw", marginLeft: "4vw" }} />
                                <AiOutlineBlock color="grey" style={{ width: "20vw", height: "20vh", marginRight: "4vw", marginLeft: "4vw" }} />
                                <Github color="black" style={{ width: "20vw", height: "20vh", marginRight: "4vw", marginLeft: "4vw" }} />

                            </div>
                        </Box>
                        <Box animation={[{ "type": "zoomIn", "duration": 2500 }]} direction="row-responsive" responsive={true} style={{ alignItems: "center" }} justify="center">
                            <div>

                                <SiGooglecloud color="orange" style={{ width: "20vw", height: "20vh", marginRight: "4vw", marginLeft: "4vw" }} />
                                <Mysql color="blue" style={{ width: "20vw", height: "20vh", marginRight: "4vw", marginLeft: "4vw" }} />
                                <SiPostgresql color="blue" style={{ width: "20vw", height: "20vh", marginRight: "4vw", marginLeft: "4vw" }} />
                            </div>
                        </Box>
                        <Box animation={[{ "type": "zoomIn", "duration": 2500 }]} direction="row-responsive" responsive={true} style={{ alignItems: "center" }} justify="center">
                            <div>
                                <FaAws style={{ width: "20vw", height: "20vh", marginRight: "4vw", marginLeft: "4vw" }} />
                                <FaPython color="grey" style={{ width: "20vw", height: "20vh", marginRight: "4vw", marginLeft: "4vw" }} />
                                <FaJava style={{ width: "20vw", height: "20vh", marginRight: "4vw", marginLeft: "4vw" }} />
                            </div>
                        </Box>
                        <Box animation={[{ "type": "zoomIn", "duration": 2500 }]} direction="row-responsive" responsive={true} style={{ alignItems: "center" }} justify="center">
                            <div>
                                <FcLinux style={{ width: "20vw", height: "20vh", marginRight: "4vw", marginLeft: "4vw" }} />

                                <FaGitAlt color="#E62B19" style={{ width: "20vw", height: "20vh", marginRight: "4vw", marginLeft: "4vw" }} />

                                <SiFlutter color="#86CDFF" style={{ width: "20vw", height: "20vh", marginRight: "4vw", marginLeft: "4vw" }} />
                            </div>
                        </Box>
                        
                    </>
                    ) : (
                        <>
                            <Box animation={[{ "type": "zoomIn", "duration": 3000 }]} direction="row-responsive" responsive={true} justify="center" style={{ marginBottom: "8vh" }}>
                                <Tip content="Node">
                                    <Node color="green" style={{ width: "10vw", height: "10vh" }} />
                                </Tip>
                                <Tip content="React">
                                    <Reactjs color="#00ffff" style={{ width: "10vw", height: "10vh" }} />
                                </Tip>
                                <Tip content="Windows">
                                    <Windows style={{ width: "10vw", height: "10vh" }} />
                                </Tip>
                                <Tip content="Typescript">
                                    <Box>
                                        <SiTypescript color="#2C77AC" style={{ width: "10vw", height: "10vh" }} />
                                    </Box>
                                </Tip>
                                <Tip content="Blockchain">
                                    <Box>
                                        <AiOutlineBlock color="grey" style={{ width: "10vw", height: "10vh" }} />
                                    </Box>
                                </Tip>
                            </Box>

                            <Box animation={[{ "type": "zoomIn", "duration": 3000 }]} direction="row-responsive" responsive={true} justify="center" style={{ marginBottom: "8vh" }}>
                                <Tip content="Github">
                                    <Github color="black" style={{ width: "10vw", height: "10vh" }} />
                                </Tip>
                                <Tip content="Google Cloud Services">
                                    <Box>
                                        <SiGooglecloud color="orange" style={{ width: "10vw", height: "10vh" }} />
                                    </Box>
                                </Tip>
                                <Tip content="MySQL">
                                    <Mysql color="blue" style={{ width: "10vw", height: "10vh" }} />
                                </Tip>
                                <Tip content="PostgreSQL">
                                    <Box>
                                        <SiPostgresql color="blue" style={{ width: "10vw", height: "10vh" }} />
                                    </Box>
                                </Tip>
                                <Tip content="Aws">
                                    <Box>
                                        <FaAws style={{ width: "10vw", height: "10vh" }} />
                                    </Box>
                                </Tip>
                            </Box>
                            <Box animation={[{ "type": "zoomIn", "duration": 3000 }]} direction="row-responsive" responsive={true} justify="center" style={{ marginBottom: "8vh" }}>
                                <Tip content="Python">
                                    <Box>
                                        <FaPython color="grey" style={{ width: "10vw", height: "10vh" }} />
                                    </Box>
                                </Tip>
                                <Tip content="Java">
                                    <Box>
                                        <FaJava style={{ width: "10vw", height: "10vh" }} />
                                    </Box>
                                </Tip>
                                <Tip content="Linux">
                                    <Box>
                                        <FcLinux style={{ width: "10vw", height: "10vh" }} />
                                    </Box>
                                </Tip>
                                <Tip content="Git">
                                    <Box>
                                        <FaGitAlt color="#E62B19" style={{ width: "10vw", height: "10vh" }} />
                                    </Box>
                                </Tip>
                                <Tip content="Flutter">
                                    <Box>
                                        <SiFlutter color="#86CDFF" style={{ width: "10vw", height: "10vh" }} />
                                    </Box>
                                </Tip>

                            </Box>
                        </>
                    )
                }
            </ResponsiveContext.Consumer >
            <Box animation={[{ "type": "slideLeft", "duration": 2750 }]} direction="row-responsive" pad="small" responsive={true} justify="center">
                <Paragraph size={styleTextHeader.size} color={styleTextHeader.color} textAlign="center">
                    {state.checked === false ? (<>Projetos</>) : (<>Projects</>)}
                </Paragraph>
            </Box>
            <Box animation={[{ "type": "slideRight", "duration": 3000 }]} direction="row-responsive" responsive={true} justify="center">
                <Paragraph style={{ textAlign: 'justify', marginRight: '5%', marginLeft: '5%', }} size={styleTextContent.size} color={styleTextHeader.color} alignSelf="center">
                    {state.checked === false ? (<>A maioria dos meus projetos de programação estão disponíveis no <Anchor href="https://github.com/pedromtelho">GitHub</Anchor>.
                    Porém, alguns deles foram marcantes durante minha jornada nos estudos de programação. <div><br /></div>Alguns deles se tornaram matérias do jornal da minha universidade, como: meu
                     <Anchor href="https://www.insper.edu.br/noticias/blockchain-pode-contribuir-para-o-fortalecimento-da-democracia/"> projeto de iniciação tecnológica e científica</Anchor> e
                        meu <Anchor href="https://www.insper.edu.br/noticias/estudantes-desenvolvem-software-para-auxiliar-pessoas-com-deficiencia-visual/">projeto de conclusão de curso</Anchor> 
                       realizado em parceria com a <Anchor href="https://www.utrgv.edu/en-us/">Universidade do Texas Rio Grande Valley</Anchor> em que desenvolvemos uma solução edge computing 
                       capaz de auxiliar pessoas com deficiência visual a se locomoveram pela cidade identificando através de computação visual, modelos de rede neural e técnicas de transfer learning: obstáculos,
                        lugares essas pessoas gostariam de ir e outros objetos definidos pelo próprio usuário via comando de voz. 
                        <div><br /></div>
                        Atualmente, estou a desenvolver um <Anchor href="https://dev.dminfdmms5zo6.amplifyapp.com/">projeto pessoal</Anchor> relacionado a tokenização. 
                    Nele, as pessoas podem criar suas próprias criptomoedas e tokenizar ativos no topo da rede Ethereum. Nesse projeto estou a utilizar o framework Nest com a linguagem Typescript para backend
                    e o framework React para a aplicação web, também utilizo a linguagem de programação Solidity para a criação dos contratos inteligentes. Além disso, toda a base de dados está sendo controlada em
                    serviços de nuvem. Futuramente pretendo adicionar features para criação de tokens em outras blockchains.</>) 
                        : 
                        (<>Most of my programming projects are available on <Anchor href="https://github.com/pedromtelho">GitHub</Anchor>.
                        Although, two of them were remarkable for me during my studies journey. <div><br /></div>These two projects were published on my university journal:
                     <Anchor href="https://www.insper.edu.br/noticias/blockchain-pode-contribuir-para-o-fortalecimento-da-democracia/"> technologic and scientific initiation</Anchor> and
                    my <Anchor href="https://www.insper.edu.br/noticias/estudantes-desenvolvem-software-para-auxiliar-pessoas-com-deficiencia-visual/">capstone project </Anchor> 
                        created in partnership with <Anchor href="https://www.utrgv.edu/en-us/">University of Texas Rio Grande Valley</Anchor> where we developed an edge computing solution
                        capable of helping people who are blind or with visual impairment to get around places identifying through computer vision, neural network models and transfer learning techniques: obstacles, 
                        places these people would like to go and other objects defined by the user via voice command. 
                        <div><br /></div>
                        Currently, I am developing a <Anchor href="https://dev.dminfdmms5zo6.amplifyapp.com/">personal project</Anchor> related to tokenization process.
                         People who wants to create their own cryptocurrency or who wants to tokenize their assets can use my platform on top of Ethereum blockchain. In this project 
                         I am using Nest framework with Typescript programming language for backend and React framework for web application frontend, I am also using Solidity language for
                          smart contracts purpose. All database is being managed by cloud services and in the future I intend to create many integrations with other blockchains.
                        </>)}
                </Paragraph>
               
            </Box>
            <Box animation={[{ "type": "slideLeft", "duration": 2750 }]} direction="row-responsive" pad="small" responsive={true} justify="center">
                <Paragraph size={styleTextHeader.size} color={styleTextHeader.color} textAlign="center">
                    {state.checked === false ? (<>No meu tempo livre...</>) : (<>In my free time...</>)}
                </Paragraph>
            </Box>
            <Box animation={[{ "type": "slideRight", "duration": 3000 }]} direction="row-responsive" responsive={true} justify="center">
                <Paragraph style={{ textAlign: 'justify', marginRight: '5%', marginLeft: '5%', }} size={styleTextContent.size} color={styleTextHeader.color} alignSelf="center">
                    {state.checked === false ? (<>Uma das coisas que amo fazer é tocar violão e outros instrumentos. Desde pequeno a música tem o poder de me
                        acalmar, e me ensina a cada dia a ter mais resiliência para superar meus desafios.</>) : (<>One of things I love to do is to play my guitar and other instruments. Since
                            I was a child music has the power to keep me calm and it teaches me everyday to be more resilient and to overcome my challenges.</>)}
                </Paragraph>

            </Box>
            <Box animation={[{ "type": "slideRight", "duration": 3000 }]} direction="row-responsive" responsive={true} justify="center">
                <Paragraph style={{ textAlign: 'justify', marginRight: '5%', marginLeft: '5%', }} size={styleTextContent.size} color={styleTextHeader.color} alignSelf="center">
                    {state.checked === false ? (<>Além disso, amo praticar esportes! Atualmente pratico triathlon e tenho o objetivo de que em algum momento eu consiga realizar
                        minha primeira maratona e meu primeiro Ironman.</>) : (<>Also, I love to play sports! Actually I do triathlon and my objective is to complete my first
                            marathon and my first Ironman.</>)}
                </Paragraph>
            </Box>
            <Box animation={[{ "type": "slideLeft", "duration": 2750 }]} direction="row-responsive" pad="small" responsive={true} justify="center">
                <Paragraph size={styleTextHeader.size} color={styleTextHeader.color} textAlign="center">
                    {state.checked === false ? (<>{"Contate-me :)"}</>) : (<>{"Contact me :)"}</>)}

                </Paragraph>
            </Box>

        </>
    );

}

export default Content;